import { render, staticRenderFns } from "./password.vue?vue&type=template&id=be253bbc&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=be253bbc&prod&scoped=true&lang=less"
import style1 from "./password.vue?vue&type=style&index=1&id=be253bbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be253bbc",
  null
  
)

export default component.exports